/**
 * SouFit Cart Bump — Linhas separadas de potes grátis
 *
 * Regra: paid >= 2 → 1 grátis  |  paid >= 3 → 2 grátis (teto absoluto)
 */

const COMBO = new Set([
  '7977517678675','7977517809747','7977517875283','7977517908051','7977517973587',
  '7977518006355','7979164598355','7979164631123','7979164663891','7979164696659',
  '7979164729427','7979164762195','7979164794963','7979164827731','7979164860499',
  '7979164893267','7979164926035','7979164958803','7979164991571'
]);

const FREE_KEY  = '_free';
const BUSY_ATTR = 'data-soufit-bump';
let debTimer = null;

// Calcula quantas unidades devem ser grátis baseado nas pagas
function calcFree(paidQty) {
  if (paidQty >= 3) return 2;
  if (paidQty >= 2) return 1;
  return 0;
}

async function runSync() {
  if (document.body.hasAttribute(BUSY_ATTR)) return;
  document.body.setAttribute(BUSY_ATTR, '');

  try {
    const cart = await fetch('/cart.js').then(r => r.json());

    // Agrupa itens por produto: separando "pago" de "grátis"
    const byPid = {};
    cart.items.forEach((item, i) => {
      const pid = String(item.product_id);
      if (!COMBO.has(pid)) return;
      if (!byPid[pid]) byPid[pid] = { paid: [], free: [] };
      const isFree = item.properties && item.properties[FREE_KEY] === 'true';
      byPid[pid][isFree ? 'free' : 'paid'].push({ ...item, lineNum: i + 1 });
    });

    for (const { paid, free } of Object.values(byPid)) {
      const paidQty   = paid.reduce((s, l) => s + l.quantity, 0);
      const shouldFree = calcFree(paidQty);
      const hasFree   = free.reduce((s, l) => s + l.quantity, 0);

      if (shouldFree === hasFree) continue; // já está certo, nada a fazer

      if (shouldFree === 0) {
        // Remove a linha grátis
        if (free.length > 0) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: free[0].lineNum, quantity: 0 })
          });
        }
      } else if (free.length === 0) {
        // Cria a linha grátis
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: paid[0].variant_id,
            quantity: shouldFree,
            properties: { [FREE_KEY]: 'true' }
          })
        });
      } else {
        // Corrige a quantidade da linha grátis existente
        // Rebusca o carrinho para ter a posição atual correta
        const fresh = await fetch('/cart.js').then(r => r.json());
        const freePos = fresh.items.findIndex(i =>
          COMBO.has(String(i.product_id)) &&
          i.properties && i.properties[FREE_KEY] === 'true'
        );
        if (freePos >= 0) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: freePos + 1, quantity: shouldFree })
          });
        }
      }
    }
  } catch (err) {
    console.warn('[soufit-bump]', err);
  } finally {
    document.body.removeAttribute(BUSY_ATTR);
  }
}

function scheduleSync() {
  // Não agenda se o bump está em andamento
  if (document.body.hasAttribute(BUSY_ATTR)) return;
  clearTimeout(debTimer);
  debTimer = setTimeout(runSync, 700);
}

// Escuta atualização de carrinho — pula se o próprio bump está rodando
document.addEventListener('cart:update', () => {
  if (document.body.hasAttribute(BUSY_ATTR)) return;
  scheduleSync();
});

// Página de carrinho
if (window.location.pathname.startsWith('/cart')) {
  scheduleSync();
}
